// extracted by mini-css-extract-plugin
export default {"wrapper":"YJo5oxu9BatEnxWHFCon","breadcrumb":"r7X6_KIdq55TLvTaHJtI"};